// extracted by mini-css-extract-plugin
export default {"step":"SetNewPassword_step--UjE","backButton":"SetNewPassword_backButton--k8U"};